import Cookies from 'js-cookie';

export const storedCookiesName = 'sleever-machines-cookies';
export const storedCookies = Cookies.get(storedCookiesName);
